module.exports = __webpack_public_path__ + "97f2e70556595c3301ca1ba4760f7e86.png";